import React from "react";

import { timer_Small } from "../../../../storybook-components/src/lib/Icons";

const TestObject = () => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {/* First Image */}
      <img
        src={timer_Small}
        alt="First"
        style={{ width: "150px", height: "150px", marginRight: "10px" }}
      />

      {/* Connection Line */}
      <div
        style={{
          width: "50px",
          height: "2px",
          backgroundColor: "black",
          marginRight: "10px",
        }}
      ></div>

      {/* Second Image */}
      <img
        src={timer_Small}
        alt="Second"
        style={{ width: "150px", height: "150px" }}
      />
    </div>
  );
};

export default TestObject;
